import { faQuestionCircle, faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { TPageTitleProps } from "../../Types";
import Et3CustomizedButton from "../et3-button/Et3CustomizedButton";
import ET3Div from "../et3-div";
import Et3Text from "../et3-text";
import Et3Margin from "../et3-ui/ET3Margin";

const Et3PageTitle = withLiteObserverAndTheme<TPageTitleProps>((props) => {
  const { title, subTitle, withRefresh, withHelper, onPress, theme } = props;
  const { colors, unitX, unitY } = theme;
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1550}
      height={95}
      fDirection="row"
      alignItems="space-between"
      justifyContent="space-between"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1338}
        height={95}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          text={`${title} `}
          fontFamily="BOLD"
          fontSize={31}
          color={colors.all.black}
          isSpan={false}
          style={{}}
        />
        <Et3Margin left={5} right={5} top={0} bottom={0} />
        <Et3Text
          text={subTitle}
          fontFamily="LIGHT"
          fontSize={20}
          color={colors.all.dimGray}
          isSpan={false}
          style={{}}
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={140}
        height={95}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        {withRefresh ? (
          <Et3CustomizedButton
            withShadow={false}
            alignItems={"center"}
            justifyContent={"center"}
            fDirection="column"
            isEnabled={true}
            width={40}
            height={40}
            color={colors.all.transparent}
            style={{}}
            onClick={() => onPress()}
          >
            <FontAwesomeIcon
              icon={faSync}
              color={colors.all.bondiBlue}
              style={{
                width: 35 * unitX,
                height: 35 * unitY
              }}
            />
          </Et3CustomizedButton>
        ) : null}
        {withHelper ? (
          <Et3CustomizedButton
            withShadow={false}
            alignItems={"center"}
            justifyContent={"center"}
            fDirection="column"
            isEnabled={true}
            width={40}
            height={40}
            color={colors.all.transparent}
            style={{}}
            onClick={() => onPress()}
          >
            <FontAwesomeIcon
              icon={faQuestionCircle}
              color={colors.all.bondiBlue}
              style={{
                width: 35 * unitX,
                height: 35 * unitY
              }}
            />
          </Et3CustomizedButton>
        ) : null}
      </ET3Div>
    </ET3Div>
  );
});

export default Et3PageTitle;
